export default __webpack_public_path__ + "static/media/corn.886a9b57.svg";